const PartnerReadOnlyRow = ({ t, supplierCompanyId, partner, handleDeleteClick, handleEditClick, handleDetailsClick, oddIdx }) => {
	return (
		<tr>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partner.companyName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partner.partnerNumber}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partner.companyTypeDesc}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partner.address}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partner.addUpdateSurvey}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partner.canShareBrokerWithBuyer}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partner.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<button className="btn btn-primary btn-block me-3 mb-0" onClick={(event) => handleEditClick(event, partner)}>{t("page.edit")}</button>
				<button className="btn btn-primary btn-block me-3 mb-0" onClick={(event) => handleDeleteClick(event, partner.partnershipKey, partner.companyId, partner.statusCode)}>{partner.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
				{(supplierCompanyId && supplierCompanyId !== 0) ? (<>
					<button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleDetailsClick(event, partner)}>{t("page.details")}</button>
				</>
				) : (<> </>)
				}
			</td>
		</tr>
	)
}
export default PartnerReadOnlyRow;